module.exports = __webpack_public_path__ + "img/telefoon-icon.6101e1d0ce8c9591748d54a718d37880.svg";